import "./App.css";
import TicTacToe from "./Components/TicTacToe";

function App() {
  return (
    <div>
      <TicTacToe></TicTacToe>
    </div>
  );
}

export default App;
